import { render, staticRenderFns } from "./EcocardioDatiEdit.vue?vue&type=template&id=a264c398&scoped=true"
import script from "./EcocardioDatiEdit.vue?vue&type=script&lang=js"
export * from "./EcocardioDatiEdit.vue?vue&type=script&lang=js"
import style0 from "./EcocardioDatiEdit.vue?vue&type=style&index=0&id=a264c398&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a264c398",
  null
  
)

export default component.exports